/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { LabelTextField } from '../../user/components/Profile';

const useStyle = makeStyles((theme) => ({
  magicCodeContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
  sendButton: {
    borderRadius: 8,
    flexShrink: 0,
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5, 1),
  },
}));
export default ({
  onSendButtonClick: propsOnSendButtonClick,
}) => {
  const classes = useStyle();
  const [errors, setErrors] = useState({});
  const [magicCode, setMagicCode] = useState('');

  const onSendButtonClick = async () => {
    if (isEmpty(magicCode)) return;

    setErrors({});

    const result = await propsOnSendButtonClick(magicCode);
    const { status, message } = result || {};

    if (status === 'success') {
      setMagicCode('');
    } else {
      setErrors({
        magicCode: {
          message,
        },
      });
    }
  };

  return (
    <div className={classes.magicCodeContainer}>
      <LabelTextField
        errors={errors}
        label="優惠券兌換碼"
        name="magicCode"
        onChange={(e) => { setMagicCode(e.target.value); }}
        placeholder="請輸入兌換碼"
        value={magicCode}
      />
      <Button
        className={classes.sendButton}
        color="primary"
        disabled={isEmpty(magicCode)}
        onClick={onSendButtonClick}
        variant="contained"
      >
        領取優惠券
      </Button>
    </div>
  );
};
